var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimboloVirtueyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 483.02 483.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #37b1c9;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.51,0c133.38,0,241.51,108.12,241.51,241.51s-108.13,241.51-241.51,241.51S0,374.89,0,241.51,108.13,0,241.51,0h0ZM18.65,231.83L231.83,18.65c5.33-5.33,14.03-5.33,19.36,0l213.18,213.18c5.32,5.32,5.32,14.03,0,19.36l-213.18,213.18c-5.32,5.33-14.03,5.33-19.36,0L18.65,251.19c-5.33-5.32-5.33-14.03,0-19.36ZM241.51,116.35c69.12,0,125.15,56.03,125.15,125.15s-56.03,125.15-125.15,125.15-125.15-56.03-125.15-125.15,56.03-125.15,125.15-125.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimboloVirtueyes);
export default __webpack_public_path__ + "static/media/simbolo-virtueyes.000293146d6b89cb420d534ddf357734.svg";
export { ForwardRef as ReactComponent };